import { ListiniVenditaComponent } from "./listini-vendita.component";
import { Routes, RouterModule } from "@angular/router";
import { NgModule } from "@angular/core";
import { CustomLayoutComponent } from "../layout/custom-layout/custom-layout.component";

const routes: Routes = [
    {
        path: 'listini-vendita',
        component: CustomLayoutComponent,
        children: [
            { path: '', component: ListiniVenditaComponent },
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class ListiniVenditaRoutingModule { }